export default __webpack_public_path__ + "static/Evistamp_Terms of Service v1.0-d69aebf8202a4b7c119a943a4a4107be.pdf";